// extracted by mini-css-extract-plugin
module.exports = {"contentWrapper":"Cta_contentWrapper__0mqal","headline":"Cta_headline__mo0k_","text":"Cta_text__G78xV","button":"Cta_button__tn2PS"};